import { Button, Card, CardDescription, CardTitle } from "../ui/index.js";

function listCarriers(labels: string[]) {
  if (labels.length <= 1) return labels[0] ?? "";
  return `${labels.slice(0, -1).join(", ")} and ${labels[labels.length - 1]}`;
}

/**
 * The one next step after a contract request for carriers handled in the
 * organization's own SureLC. Submitting on Altura does not appoint anyone, so
 * this never says the request succeeded. It names the organization, never
 * the IMO behind it (Paul, Oct 28).
 */
export function InsuranceBayCard({
  organizationName,
  carrierLabels,
  canOpen,
  opening,
  error,
  onOpen,
}: {
  organizationName: string;
  carrierLabels: string[];
  canOpen: boolean;
  opening: boolean;
  error: string | null;
  onOpen: () => void;
}) {
  return (
    <Card padding="lg" className="space-y-4 border-2 border-accent-strong">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <CardTitle>Keep applying in your {organizationName} Insurance Bay</CardTitle>
          <CardDescription className="mt-1">
            Your request for {listCarriers(carrierLabels)} is not finished yet. Open your Insurance Bay to
            review, sign, and send it.
          </CardDescription>
        </div>
        <Button className="shrink-0" size="lg" onClick={onOpen} disabled={!canOpen || opening}>
          {opening ? "Opening…" : `Access your ${organizationName} Insurance Bay`}
        </Button>
      </div>
      {!canOpen ? (
        <p className="text-sm text-content-secondary">
          We are still setting up your Insurance Bay account. This button opens it as soon as it is ready.
        </p>
      ) : null}
      {error ? (
        <p className="text-sm text-status-rejected-text" role="alert">
          {error}
        </p>
      ) : null}
    </Card>
  );
}
